const font = {
  size38: "38px",
  size30: "30px",
  size24: "24px",
  size20: "20px",
  size16: "16px",
  size14: "14px",
  size12: "12px",
};

export default font;
